module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "dedicationPage"
  }, [_c('a', {
    attrs: {
      "id": "title17"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "p-c"
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_vm._v("For my mother and father, Alice and William Page,"), _c('br'), _vm._v(" who first brought me to the island")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57afc168","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781466806597_ded01.vue
// module id = 63
// module chunks = 0